const doc = [({"en":({"adminConstantDayOfWeekShort":({"friday":"Fri", "monday":"Mon", "saturday":"Sat", "sunday":"Sun", "thursday":"Thu", "tuesday":"Tue", "wednesday":"Wed"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;